import Repository from './Repository'

export default {
  get(payload) {
    return Repository.get('/users', payload)
  },
  post(payload) {
    return Repository.post('/users', payload)
  },
  detail(id) {
    return Repository.get('/users/' + id)
  },
  put(payload) {
    return Repository.put('/users/' + payload.user_id, payload)
  },
  delete(id) {
    return Repository.delete('/users/' + id)
  }
}

